module.exports = __webpack_public_path__ + "2e483afd66433b7d7c1d13ebeaff9b77.png";